import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    initialize() {
        super.initialize();
        this.typeTimer = null;
    }

    updateWeekQuery(event) {
        clearTimeout(this.typeTimer);

        this.typeTimer = setTimeout(() => {
            const root = this.element;
            const yearEl = root.querySelector('._date_year');
            const weekEl = root.querySelector('._date_week');
            const promoEl = root.querySelector('._date_promo_filter');

            const year = yearEl?.value?.trim();
            const week = weekEl?.value?.trim();
            const promo = !!promoEl?.checked;

            const params = new URLSearchParams(window.location.search);

            if (year) params.set('_year_year', year); else params.delete('_year_year');
            if (week) params.set('_year_week', week); else params.delete('_year_week');
            if (promo) params.set('_filter_by_promo_week', '1');
            else params.set('_filter_by_promo_week', '0');

            params.delete('page');

            const next = `${location.pathname}?${params.toString()}`;
            if (window.Turbo?.visit) Turbo.visit(next);
            else window.location.assign(next);
        }, 500);
    }
}
